import { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import Dropdown from 'react-bootstrap/Dropdown';
import './Dropdown.scss';

function AppDropdown(props) {
    const [current, setCurrent] = useState(props.data[0]);
    const [data, setData] = useState(props.data);

    function onDDItemClick(item) {
        setCurrent(item);
        props.onDDClick(item);
    }

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setData(props.data);
            if (props.current) setCurrent(props.current);
            else setCurrent(props.data[0]);
        }
    }, [props.data])

    if (data && data.length > 0)
        return (
            <Dropdown className="appdropdown">
                <Dropdown.Toggle className="appdropdown-top">
                    <div> {props.intl.formatMessage({ id: current.intl || "" })}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {data.map((item, i) => (
                        <Dropdown.Item key={`dropdownMenuItem${i}`}
                            onClick={onDDItemClick.bind(null, item)}>
                            {props.intl.formatMessage({ id: item.intl || "" })}
                        </Dropdown.Item>))}
                </Dropdown.Menu>
            </Dropdown>)

    return (<div></div>)
}

export default injectIntl(AppDropdown);